import * as yup from "yup"

export const depreciationValidation = yup.object().shape({
    depreciation_period: yup.string().label("Depreciation Period").required(),
    depreciation_methode: yup.string().label("Depreciation Method").required(),
    depreciation_expences: yup.number().label("Depreciation Expences").optional(),
    depreciation_rate : yup.number().label(" Depreciation Rate").required(),
    asset_id : yup.string().label("Asset ID").optional(),
    asset_infodepreciation_id : yup.string().label("").optional(),
    depreciation_accumulation: yup.number().label("Depreciation Accumulation").optional()
})

export type DepreciationType = yup.InferType<typeof depreciationValidation>